import type { AppState, MutationClass } from '../../../models'

export class SetLoadingMutation implements MutationClass {
  static execute(this: void, state: AppState, { loading }: Pick<AppState, 'loading'>): void {
    state.loading = loading
  }
}
